import {
  FundingOption,
  FundingOptionItem,
  FundingOriginInput,
} from '@varo/graphql-schema-types';
import { router } from 'expo-router';
import DirectDepositLoader from 'features/directDeposit/screens/DirectDepositLoader';
import FundingSelectionScreen from 'features/onboarding/components/FundingSelectionScreen/FundingSelectionScreen';
import useFundingNavigation from 'features/onboarding/hooks/useFundingNavigation';
import useGetFundingOptions from 'features/onboarding/hooks/useGetFundingOptions';
import React from 'react';
import { useTranslation } from 'react-i18next';
import FullScreenLoading from 'shared/components/vxl/loading/FullScreenLoading/FullScreenLoading';
import { useViewDidFocusScreenAnalyticsEvent } from 'shared/hooks/analytics/useViewDidFocusAnalytics';
import { useDefaultErrorStrings } from 'shared/hooks/errorFormatters/useDefaultError/useDefaultErrorStrings';
import {
  ErrorScreen,
  ErrorScreenType,
} from 'shared/patterns/vxl/errors/ErrorScreen/ErrorScreen';
import ScreenTransitionOverlay from 'shared/patterns/vxl/ScreenTransitionOverlay/ScreenTransitionOverlay';

const ProgressTrackerFunding = () => {
  const { fundingOptionsData, error, fetching } = useGetFundingOptions({
    origin: FundingOriginInput.Checklist,
  });

  const { defaultMessage, graphqlErrorsTitle } = useDefaultErrorStrings();
  const { t: translatedText } = useTranslation('onboarding');

  const { navigateFundingAction, pinWheelLoading } = useFundingNavigation();

  useViewDidFocusScreenAnalyticsEvent({
    key: 'progress_tracker_funding',
  });

  const handleContinueButton = (type?: string) => {
    if (!type) {
      return;
    }

    const selectedFundingOption = fundingOptionsData?.options
      ? (fundingOptionsData.options as FundingOptionItem[]).find(
          (option) => option.type === type,
        )
      : undefined;

    if (!selectedFundingOption) {
      return;
    }

    navigateFundingAction(
      selectedFundingOption.type as FundingOption,
      (outcome) => {
        if (outcome?.success) {
          router.replace('/');
        }
      },
    );
  };

  if (!fundingOptionsData) {
    return (
      <ScreenTransitionOverlay
        isLoading={fetching || pinWheelLoading}
        LoadingComponent={<FullScreenLoading isCoinLoader />}
        ErrorComponent={
          error ? (
            <ErrorScreen
              screenType={ErrorScreenType.Error}
              messageHeadline={graphqlErrorsTitle}
              messageBody={defaultMessage}
              primaryButton={{
                title: translatedText('errors.goToHomePageButtonLabel'),
                onPress: () => {
                  router.push('/');
                },
              }}
            />
          ) : null
        }
      />
    );
  }

  return (
    <>
      <FundingSelectionScreen
        optionsData={fundingOptionsData.options}
        headlineText={fundingOptionsData.title}
        onContinueButton={handleContinueButton}
      />
      <ScreenTransitionOverlay
        isLoading={pinWheelLoading}
        LoadingComponent={
          <DirectDepositLoader
            isLoadingConditions={false}
            isPinwheelLoading={pinWheelLoading}
            defaultLoadingComponent={<FullScreenLoading isCoinLoader />}
          />
        }
        ErrorComponent={null}
      />
    </>
  );
};

export default ProgressTrackerFunding;
